import React from 'react'
import { connect } from 'react-redux'
import * as actions from '../../store/actions'
import ZasadyRachunkowosciStyle from '../../styles/ZasadyRachunkowosciStyle'
import MainStyle from '../../styles/MainStyle'
import PolitykaRachunkowosci from '../../components/ZasadyRachunkowosci/PolitykaRachunkowosci'
import PolitykaRachunkowosciV12 from '../../components/ZasadyRachunkowosci/PolitykaRachunkowosciV12'
import PolitykaRachunkowosciSkrocona from '../../components/ZasadyRachunkowosci/PolitykaRachunkowosciSkrocona'
import PolitykaRachunkowosciSkonsolidowana from '../../components/ZasadyRachunkowosci/PolitykaRachunkowosciSkonsolidowana'
import PolitykaRachunkowosciSkonsolidowanaV12 from '../../components/ZasadyRachunkowosci/PolitykaRachunkowosciSkonsolidowanaV12'

class ZasadyRachunkowosci extends React.Component {
  render() {
    const {
      onSetSectionData,
      sectionList,
      validityErrors,
      czyPodsumowanie,
    } = this.props
    return (
      <MainStyle>
        <ZasadyRachunkowosciStyle>
          {sectionList.map((data, index) => {
            switch (data.TypSekcji) {
              case 'PolitykaRachunkowosci':
                return (
                  <PolitykaRachunkowosci
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === 'PolitykaRachunkowosci',
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    czyPodsumowanie={czyPodsumowanie}
                  />
                )
              case 'PolitykaRachunkowosci_v1_2':
                return (
                  <PolitykaRachunkowosciV12
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) => value.TypSekcji === 'PolitykaRachunkowosci',
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    czyPodsumowanie={czyPodsumowanie}
                  />
                )
              case 'PolitykaRachunkowosciSkrocona':
                return (
                  <PolitykaRachunkowosciSkrocona
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) =>
                        value.TypSekcji === 'PolitykaRachunkowosciSkrocona',
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    czyPodsumowanie={czyPodsumowanie}
                  />
                )
              case 'PolitykaRachunkowosciSkonsolidowana':
                return (
                  <PolitykaRachunkowosciSkonsolidowana
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) =>
                        value.TypSekcji ===
                        'PolitykaRachunkowosciSkonsolidowana',
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    czyPodsumowanie={czyPodsumowanie}
                  />
                )
              case 'PolitykaRachunkowosciSkonsolidowana_v1_2':
                return (
                  <PolitykaRachunkowosciSkonsolidowanaV12
                    key={index}
                    data={data.Dane}
                    errors={validityErrors.filter(
                      (value) =>
                        value.TypSekcji ===
                        'PolitykaRachunkowosciSkonsolidowana_v1_2',
                    )}
                    onSetSectionData={(name, value) =>
                      onSetSectionData(name, value, index)
                    }
                    czyPodsumowanie={czyPodsumowanie}
                  />
                )
              default:
                return null
            }
          })}
        </ZasadyRachunkowosciStyle>
      </MainStyle>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    validityErrors: state.sprawozdanie.validityErrors
      ? state.sprawozdanie.validityErrors
      : [],
    czyPodsumowanie: state.sprawozdanie.czyPodsumowanie,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onSetSectionData: (name, value, index) => {
      dispatch(actions.setSectionData(name, value, index))
    },
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(ZasadyRachunkowosci)
